<template>
    <v-menu
        v-model="showModal"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
        :disabled="disabled"
        :min-width="minWidth"
        :max-width="maxWidth"
    >
        <template #activator="{ on, attrs }">
            <template v-if="findSlot('activator')">
                <slot name="activator" :attrs="attrs" :on="on" />
            </template>
            <v-icon v-else color="primaryText" x-small v-bind="attrs" v-on="on">
                {{ getIcon('edit', 'fas') }}
            </v-icon>
        </template>

        <v-card v-if="!disabled">
            <v-list>
                <v-list-item>
                    <v-list-item-avatar color="background darken-3">
                        <v-icon>{{ getIcon(icon) }}</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                            {{ title }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ $t('options') }}
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <app-button-close @click="showModal = false" />
                    </v-list-item-action>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-card-text>
                <slot />
            </v-card-text>

            <v-card-actions v-if="!saveOnBlur" class="primaryLight">
                <v-spacer></v-spacer>
                <app-button :text="$t('save')" @click="onSave" />
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
import wait from '@/lib/helpers/wait';
export default {
    name: 'TiptapOptionsMenu',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'edit'
        },
        title: {
            type: String,
            default: 'Tiptap Plugin'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        saveOnBlur: {
            type: Boolean,
            default: false
        },
        openOnMounted: {
            type: Boolean,
            default: false
        },
        minWidth: {
            type: String,
            default: '30rem'
        },
        maxWidth: {
            type: String,
            default: '30rem'
        }
    },
    data: () => ({
        menu: false
    }),
    computed: {
        showModal: {
            get() {
                return this.menu;
            },
            set(v) {
                this.menu = v;
                this.$emit('input', v);
            }
        }
    },
    watch: {
        value(v) {
            this.menu = v;
        }
    },
    async mounted() {
        await wait(100);
        if (this.openOnMounted) {
            this.menu = true;
        }
    },
    methods: {
        onSave() {
            this.menu = false;
            this.$emit('save');
        }
    }
};
</script>
